import { API_PATH } from "@/constants/config";
import { normalizeLicenseTenant } from "@/converter/license";
import { request } from "@/helper/http";
import { ContractCycle, LicenseTenant, LicenseTenantServer } from "@/types/license";

export const getLicenseTenant = (): Promise<LicenseTenant> => {
  return new Promise((resolve, reject) => {
    request({
      url: API_PATH.LICENSE,
      method: "GET",
    })
      .then((res: LicenseTenantServer) => {
        resolve(normalizeLicenseTenant(res));
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getLicenseTenantUsage = (): Promise<ContractCycle> => {
  return request({
    url: API_PATH.LICENSE_USAGE,
    method: "GET",
  });
};
